"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributesWithDrillDown = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var react_1 = require("react");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dataLoaders_1 = require("../../../dataLoaders");
var utils_1 = require("../utils");
/**
 * Hook allowing to download attributes with drillDown of the given workspace
 * @param config - configuration of the hook
 * @internal
 */
function useAttributesWithDrillDown(_a) {
    var _this = this;
    var backend = _a.backend, hasDrillingEnabled = _a.hasDrillingEnabled, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess, workspace = _a.workspace;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useAttributesWithDrillDown");
    utils_1.workspaceInvariant(effectiveWorkspace, "useAttributesWithDrillDown");
    var promise = react_1.useMemo(function () {
        return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var loader;
            return tslib_1.__generator(this, function (_a) {
                if (!hasDrillingEnabled) {
                    return [2 /*return*/, []];
                }
                loader = dataLoaders_1.attributesWithDrillDownDataLoaderFactory.forWorkspace(effectiveWorkspace);
                return [2 /*return*/, loader.getAttributesWithDrillDown(effectiveBackend)];
            });
        }); };
    }, [hasDrillingEnabled, effectiveBackend, effectiveWorkspace]);
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        hasDrillingEnabled,
    ]);
}
exports.useAttributesWithDrillDown = useAttributesWithDrillDown;
//# sourceMappingURL=useAttributesWithDrillDown.js.map